import { render, staticRenderFns } from "./EconfPagamentoForm.vue?vue&type=template&id=04addeb6"
import script from "./EconfPagamentoForm.vue?vue&type=script&lang=js"
export * from "./EconfPagamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports